import { useV2Translation } from 'pages/signup/steps/OrganizationName/v2/translation';
import React from 'react';
import { StyledCityField } from './style';
import { InputAdornment } from '@mui/material';
import { CountrySelect } from './CountrySelect';

export const CityTextField: React.FC<{
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    InputProps: {
        ref: React.Ref<any>;
        className: string;
        startAdornment: React.ReactNode;
        endAdornment: React.ReactNode;
    };
    country: 'us' | 'bs';
    setCountry: (value: 'us' | 'bs') => void;
    inputProps: object;
    id: string;
    InputLabelProps: object;
    onClick: () => void;
    errorMessage?: string;
    invalid?: boolean;
    onBlur?:
        | React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>
        | undefined;
}> = ({
    value,
    onChange,
    country,
    setCountry,
    id,
    InputProps,
    inputProps,
    InputLabelProps,
    onClick,
    errorMessage,
    invalid,
    onBlur,
}) => {
    const copy = useV2Translation();

    return (
        <StyledCityField
            state={invalid ? 'error' : 'idle'}
            leftHelperText={invalid || errorMessage ? errorMessage : ''}
            variant="outlined"
            fullWidth={true}
            value={value}
            type="text"
            onChange={onChange}
            InputProps={{
                ...InputProps,
                startAdornment: (
                    <InputAdornment position="start">
                        <CountrySelect
                            country={country}
                            setCountry={setCountry}
                        />
                    </InputAdornment>
                ),
            }}
            inputProps={{
                ...(inputProps as any),
                autoComplete: 'new-password',
            }}
            InputLabelProps={{
                ...InputLabelProps,
            }}
            id={id}
            onClick={onClick}
            size="large"
            label={country === 'us' ? copy.cityLabel : copy.islandNameLabel}
            placeholder={
                country === 'us' ? copy.cityLabel : copy.islandNameLabel
            }
            onBlur={onBlur}
            name="location-autocomplete"
        />
    );
};
